import { send } from '../helpers/requests';
import { AuthProvider } from 'react-admin';
import { LoginModel } from '../types/loginModel';

const authProvider: AuthProvider = {
    login: (data: LoginModel) => {
        return send({
            method: 'post',
            url: '/users/cms/signin',
            data
        }).then(response => {
            if (response.data.error) {
                return false
            }
            localStorage.setItem("permissions", JSON.stringify(response.data.user.permissions))
            localStorage.setItem('auth', JSON.stringify(response.data.token));
            return true
        }).catch(error => {
            return Promise.reject();
        });
    },
    logout: () => {
        localStorage.removeItem('auth');
        localStorage.removeItem('permissions')
        return Promise.resolve();
    },
    checkAuth: () => localStorage.getItem('auth')
        ? Promise.resolve()
        : Promise.reject(),

    getPermissions: () => {
        const role = localStorage.getItem('permissions');
        return role ? Promise.resolve(role) : Promise.reject();
    },
    checkError: error => {
        const status = error.status;
        if (status === 401 || status === 403) {
            localStorage.removeItem('auth');
            return Promise.reject();
        }
        if (status === 400) {
            return Promise.resolve(error);
        }
        return Promise.resolve();
    },
};

export default authProvider;